import RwcAnalytics from './RwcAnalytics.page';

export default RwcAnalytics;
